// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducerad) return;

  const VARAKTIGHET = 220;
  const EASE        = 'cubic-bezier(0.4, 0, 0.2, 1)';

  const html = document.documentElement;
  const body = document.body;

  const fadeIn = () => {
    delete html.dataset.laddas;
    delete body.dataset.sidovergång;
  };

  const fadeOut = () => new Promise((resolve) => {
    body.dataset.sidovergång = 'ute';
    setTimeout(resolve, VARAKTIGHET);
  });

  fadeIn();

  document.addEventListener('click', async (e) => {
    const lank = e.target.closest('a[href]');
    if (!lank) return;

    const href = lank.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

    try {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin) return;
    } catch (_) { return; }

    if (lank.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (lank.matches('[data-action~="galleri/modal"]')) return;

    e.preventDefault();
    await fadeOut();
    window.location.assign(lank.href);
  });

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) fadeIn();
  });
})();

(() => {
  const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!window.gsap || reducerad) return;

  const gsap = window.gsap;
  if (window.CSSPlugin) gsap.registerPlugin(window.CSSPlugin);
  const varaktighet = { val: 0.22, aval: 0.14 };

  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.produkt-sida__alternativ-radio');
    if (!radio) return;

    const form = radio.closest('form');
    if (!form) return;
    const allRadios = form.querySelectorAll(`.produkt-sida__alternativ-radio[name="${CSS.escape(radio.name)}"]`);

    allRadios.forEach((r) => {
      if (r === radio) {
        gsap.to(r, {
          '--variant-radie': '50%',
          duration: varaktighet.val,
          ease: 'power2.out',
          overwrite: 'auto',
        });
      } else {
        gsap.to(r, {
          '--variant-radie': '0%',
          duration: varaktighet.aval,
          ease: 'power2.in',
          overwrite: 'auto',
        });
      }
    });
  });
})();

(() => {
  const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!window.gsap || reducerad) return;

  const gsap = window.gsap;
  const tryckIn = { '--atgard-radie': '6px', '--atgard-filter': 'blur(1.5px)', duration: 0.12, ease: 'power2.out', overwrite: 'auto' };
  const tryckUt = { '--atgard-radie': '0px', '--atgard-filter': 'blur(0px)', duration: 0.18, ease: 'power2.in', overwrite: 'auto' };

  const aterstall = (el) => { if (el) gsap.to(el, tryckUt); };

  document.addEventListener('pointerdown', (e) => {
    const el = e.target.closest('[data-action~="atgard/tryck"]');
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return;
    gsap.to(el, tryckIn);
    const slapp = () => { aterstall(el); el.removeEventListener('pointerup', slapp); el.removeEventListener('pointerleave', slapp); };
    el.addEventListener('pointerup', slapp);
    el.addEventListener('pointerleave', slapp);
  });
})();

(() => {
  const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const START = 8;
  const TROSKEL = 48;

  const bytKortbild = (kort, riktning) => {
    const bilder = Array.from(kort.querySelectorAll('.kort__bild img'));
    if (bilder.length < 2) return;

    const synlig = bilder.findIndex((b) => b.dataset.state !== 'dold');
    const aktiv = synlig === -1 ? 0 : synlig;
    const nastaIndex = (aktiv + riktning + bilder.length) % bilder.length;

    bilder.forEach((b, i) => {
      b.dataset.state = i === nastaIndex ? '' : 'dold';
    });

    const indexSpan = kort.querySelector('[data-kortindex]');
    const totalEl = kort.querySelector('[data-kortbild-total]');
    if (indexSpan) {
      const total = parseInt(totalEl?.dataset.kortbildTotal || bilder.length, 10);
      indexSpan.textContent = `${nastaIndex + 1} / ${total}`;
    }
  };

  document.addEventListener('click', (e) => {
    const fore = e.target.closest('[data-action~="kortbild/fore"]');
    const nasta = e.target.closest('[data-action~="kortbild/nasta"]');
    const knapp = fore || nasta;
    if (!knapp) return;

    e.preventDefault();
    const kort = knapp.closest('.kort');
    if (!kort) return;
    bytKortbild(kort, fore ? -1 : 1);
  });

  let svep = null;

  const nollstallSvep = (yta) => {
    if (!yta) return;
    delete yta.dataset.svep;
    yta.style.removeProperty('--svep-x');
  };

  document.addEventListener('pointerdown', (e) => {
    if (e.button != null && e.button !== 0) return;
    const yta = e.target.closest('.kort__bild');
    if (!yta) return;
    const kort = yta.closest('.kort');
    if (!kort || kort.querySelectorAll('.kort__bild img').length < 2) return;
    svep = { yta, kort, id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, aktiv: false };
  });

  document.addEventListener('pointermove', (e) => {
    if (!svep || svep.id !== e.pointerId) return;
    const dx = e.clientX - svep.x;
    const dy = e.clientY - svep.y;
    if (!svep.aktiv) {
      if (Math.abs(dx) < START && Math.abs(dy) < START) return;
      if (Math.abs(dy) >= Math.abs(dx)) {
        svep = null;
        return;
      }
      svep.aktiv = true;
      svep.yta.dataset.svep = 'ja';
      try { svep.yta.setPointerCapture(e.pointerId); } catch (_) {}
    }
    svep.dx = dx;
    if (!reducerad) svep.yta.style.setProperty('--svep-x', `${dx}px`);
  });

  const slutaSvep = (e) => {
    if (!svep || svep.id !== e.pointerId) return;
    const { yta, kort, dx, aktiv } = svep;
    svep = null;
    nollstallSvep(yta);
    if (!aktiv) return;
    yta.dataset.svepbruten = 'ja';
    if (Math.abs(dx) >= TROSKEL) bytKortbild(kort, dx < 0 ? 1 : -1);
  };

  document.addEventListener('pointerup', slutaSvep);
  document.addEventListener('pointercancel', slutaSvep);

  document.addEventListener('click', (e) => {
    const yta = e.target.closest('.kort__bild');
    if (!yta || yta.dataset.svepbruten !== 'ja') return;
    delete yta.dataset.svepbruten;
    e.preventDefault();
    e.stopPropagation();
  }, true);
})();

(function flyttaSamtyckeInstallningar() {
  function placera() {
    const banner = document.getElementById('shopify-pc__banner');
    const kropp = document.querySelector('.shopify-pc__banner__body');
    const knapp = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    const länk = document.querySelector('link[href*="base.css"]');
    if (banner && länk && länk.parentNode !== document.documentElement) {
      document.documentElement.appendChild(länk);
    }
    if (!kropp || !knapp || knapp.parentElement === kropp) return;
    kropp.appendChild(knapp);
  }
  placera();
  const spanare = new MutationObserver(placera);
  spanare.observe(document.documentElement, { childList: true, subtree: true });
})();
